import { useEffect } from "react";
import { useDispatch } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";

import { PossibleNaviationPages } from "./Navigation";
import { activateNavigationPage } from "../store/components";
import * as theme from "../theme";

const MyPolicies = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mypolicies })
    );
  }, [dispatch]);
  return (
    <GeneralAuthentication>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "GibsonLight",
          backgroundColor: theme.COLORS.help_tip,
        }}
      >
        Coming soon to next version... :)
      </div>
    </GeneralAuthentication>
  );
};

export default MyPolicies;
